import PropTypes from 'prop-types'
import useCategories from 'hooks/useCategories'
import { DARK_PAGAMO_RED } from 'constants/colors'
import { Container, Sidebar, Rows, Content, Link } from './index.style'

const SidebarContainer = ({ baseUrl, children }) => {
  const categories = useCategories(baseUrl)
  return (
    <Container>
      <Sidebar>
        <Rows>
          {categories.map(({ url, abbr }) => (
            <li key={url}>
              <Link
                to={url}
                activeStyle={{ color: DARK_PAGAMO_RED }}
              >{`. ${abbr}`}</Link>
            </li>
          ))}
        </Rows>
      </Sidebar>
      <Content>{children}</Content>
    </Container>
  )
}

SidebarContainer.propTypes = {
  baseUrl: PropTypes.string,
  children: PropTypes.node,
}

export default SidebarContainer
